'use client';

import { ResultsPerPage } from '@components/Search/ResultsPerPage';
import { Sorting } from '@components/Search/Sorting';
import { AtomicContext } from '@contexts/coveo/AtomicContext';
import { AtomicQuerySummary } from '@coveo/atomic-react';

export const AtomicQueryRefinement = ({
  context,
}: {
  context: AtomicContext;
}) => {
  return (
    <section data-test="filter-button" className="block text-sm">
      <div className="flex w-full items-center justify-between">
        <div className="w-[70%] pr-2 md:w-auto">
          <Sorting context={context} />
        </div>
        <div className="w-[30%] md:w-auto">
          <ResultsPerPage context={context} />
        </div>
      </div>
      <AtomicQuerySummary className="qs--muted mt-6 block" />
    </section>
  );
};
